<template>
  <b-modal
    :id="modalId"
    :title="$t('simulationLot.add.poste.modale.title')"
    centered
    :ok-title="$t('Valider')"
    :cancel-title="$t('Annuler')"
    ok-variant="primary"
    cancel-variant="outline-primary"
    no-close-on-backdrop
    @ok="handleOk"
    @cancel="handleCancel">

    <div class="callout">{{ $t('simulationLot.add.poste.modale.desc') }}</div>

    <div class="row mb-2 mt-4">
      <div class="col-md-12">
        <span class="bold-text custom-title">{{ simulationConstruction.name }} (Simulation)</span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <b-form-group
          :label="$t('Associer un poste')"
          class="medium-label mb-4"
          label-for="poste-input">
          <b-form-select
            id="poste-input"
            v-model="currentSelection"
            @change="addPoste"
            required>
            <option value="" selected>{{ $t('simulationLot.add.poste.modale.placeholder') }}</option>
            <option v-for="option in postes" :key="option.value" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
          <div class="selected-badges mt-4 mb-5">
            <b-badge
              v-for="poste in linkedConstructions"
              :key="poste.id"
              pill
              variant="primary"
              class="mr-2 mb-2 badge-custom">
              <span class="badge-close" @click.stop="removePoste(poste)">×</span>
              <span class="badge-text">{{ getBadgeText(poste) }}</span>
            </b-badge>
            <b-badge
              v-for="poste in selectedPostes"
              :key="poste"
              pill
              variant="primary"
              class="mr-2 mb-2 badge-custom">
              <span class="badge-close" @click.stop="removePoste(poste)">×</span>
              <span class="badge-text">{{ getPosteText(poste, postes) }}</span>
            </b-badge>
          </div>
        </b-form-group>
      </div>
    </div>

  </b-modal>
</template>

<script>
import api from '../../../services/api'

export default {
  name: "AddSimulationPosteTravauxModal",

  props: {
    simulationConstruction: {
      type: Object,
      required: true
    },
    modalId: {
      type: String,
      required: true
    },
    operationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      postes: [],
      allPostes: [],
      selectedPostes: [],
      currentSelection: '',
      uniteConstruction: 'M2',
      linkedConstructions: [],
      removedPostes: []
    }
  },

  emits: ['didAddPosteTravaux'],

  mounted() {
    console.log('Modal ouvert avec ID:', this.modalId)
  },

  methods: {
    show() {
      this.currentSelection = ""
      this.selectedPostes = []
      this.removedPostes = []

      this.fetchAvailableOperationConstructions()
      this.fetchLinkedOperations()
    },

    fetchAvailableOperationConstructions() {
      api
        .get('/simulationConstruction/getAvaiblesOperationConstruction', {
          params: {
            operationId: this.operationId
          }
        })
        .then(response => {
          console.log('OperationConstructions disponibles:', response.data)
          this.updatePostesLists()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    fetchLinkedOperations() {
      api
        .get(`/simulationConstruction/getLinkedOperations?simulationConstructionId=${this.simulationConstruction.id}`)
        .then(response => {
          console.log('Constructions liées recues:', response.data)
          const avpConstructions = response.data.constructionsAVP.map(p => ({
            ...p,
            type: 'AVP',
            operationType: 'AVP'
          }))
          const exeConstructions = response.data.constructionsEXE.map(p => ({
            ...p,
            type: 'EXE',
            operationType: 'EXE'
          }))
          this.linkedConstructions = [...avpConstructions, ...exeConstructions]
          // Mettre à jour allPostes avec les postes liés
          this.linkedConstructions.forEach(linkedPoste => {
            const existingPoste = this.allPostes.find(p => p.name === linkedPoste.name && p.operationType === linkedPoste.operationType)
            if (!existingPoste) {
              // Créer une option simple pour chaque poste
              this.allPostes.push({
                value: linkedPoste.id,
                name: linkedPoste.name,
                ids: [linkedPoste.id],
                types: [linkedPoste.operationType],
                text: `${linkedPoste.name} (${linkedPoste.operationType})`,
                operationType: linkedPoste.operationType
              })
            }
          })

        })
        .catch(error => {
          console.error('Erreur lors de la récupération des constructions liées:', error)
        })
    },

    async updatePostesLists() {
      try {
        const response = await api.get('/simulationConstruction/getAvaiblesOperationConstruction', {
          params: {
            operationId: this.operationId
          }
        })


        // Traiter les postes AVP
        const postesAVP = response.data.AVP
          .filter(poste => poste.typeConstruction && poste.typeConstruction.value === this.simulationConstruction.typeConstruction.value)
          .map(poste => ({
            value: poste.id,
            name: poste.name,
            ids: [poste.id],
            types: ['AVP'],
            text: `${poste.name} (AVP)`,
            operationType: 'AVP'
          }))

        // Traiter les postes EXE
        const postesEXE = response.data.EXE
          .filter(poste => poste.typeConstruction && poste.typeConstruction.value === this.simulationConstruction.typeConstruction.value)
          .map(poste => ({
            value: poste.id,
            name: poste.name,
            ids: [poste.id],
            types: ['EXE'],
            text: `${poste.name} (EXE)`,
            operationType: 'EXE'
          }))

        // Combiner les postes AVP et EXE (sans créer d'options combinées)
        this.allPostes = [...postesAVP, ...postesEXE].sort((a, b) => a.text.localeCompare(b.text))


        // Ajouter les postes déjà liés à la liste des postes disponibles
        const allAvailablePostes = [...this.allPostes]


        this.linkedConstructions.forEach(linkedPoste => {
          const posteComplet = this.allPostes.find(p => p.ids.includes(linkedPoste.id))

          if (posteComplet && !allAvailablePostes.some(p => p.ids.includes(linkedPoste.id))) {
            allAvailablePostes.push(posteComplet)
          }
        })

        this.postes = allAvailablePostes.sort((a, b) => a.text.localeCompare(b.text))
      } catch (error) {
        console.error('Erreur lors de la récupération des postes:', error)
        if (error.response && error.response.data) {
          console.error('Détails de l\'erreur:', error.response.data)
        }
      }
    },

    addPoste() {


      if (this.currentSelection && !this.selectedPostes.includes(this.currentSelection)) {
        // Trouver le poste par sa valeur ou par l'un de ses ids
        const poste = this.allPostes.find(p =>
          p.value === this.currentSelection ||
          p.ids.includes(this.currentSelection)
        )
        console.log('poste trouvé:', poste)

        if (poste) {


          // Ajouter un poste simple
          const newPoste = {
            id: poste.ids[0],
            name: poste.name,
            operationType: poste.operationType
          }
          this.linkedConstructions.push(newPoste)



          // Supprimer l'option sélectionnée du dropdown
          this.postes = this.postes.filter(p => p.value !== this.currentSelection)
          this.currentSelection = ""
        }
      }

    },

    getPosteText(value, options) {
      const posteComplet = this.allPostes.find(p => p.value === value || p.ids.includes(value))
      if (posteComplet) {
        return `${posteComplet.name} (${posteComplet.operationType})`
      }
      return value
    },

    getBadgeText(poste) {
      if (typeof poste === 'object') {
        return `${poste.name} (${poste.operationType})`
      }

      const posteComplet = this.allPostes.find(p => p.value === poste || p.ids.includes(poste))
      if (posteComplet) {
        return `${posteComplet.name} (${posteComplet.operationType})`
      }
      return poste
    },

    removePoste(value) {

      if (typeof value === 'object') {
        // Supprimer le poste des constructions liées
        this.linkedConstructions = this.linkedConstructions.filter(p => p.id !== value.id)


        // Ajouter le poste individuel au dropdown
        const posteToAdd = {
          value: value.id,
          name: value.name,
          ids: [value.id],
          types: [value.operationType],
          text: `${value.name} (${value.operationType})`,
          operationType: value.operationType
        }

        // Vérifier si le poste existe déjà dans le dropdown
        const existingPosteIndex = this.postes.findIndex(p => p.value === value.id)
        if (existingPosteIndex >= 0) {
          this.postes[existingPosteIndex] = posteToAdd
        } else {
          this.postes.push(posteToAdd)
        }

        // Ajouter ou mettre à jour le poste dans allPostes
        const existingAllPosteIndex = this.allPostes.findIndex(p => p.value === value.id)
        if (existingAllPosteIndex >= 0) {
          this.allPostes[existingAllPosteIndex] = posteToAdd
        } else {
          this.allPostes.push(posteToAdd)
        }

        this.postes.sort((a, b) => a.text.localeCompare(b.text))
      } else {
        // Gestion des postes pré-sélectionnés
        const foundPoste = this.linkedConstructions.find(p => p.id === value)
        if (foundPoste) {
          // Supprimer le badge
          this.linkedConstructions = this.linkedConstructions.filter(p => p.id !== value)

          // Ajouter le poste individuel au dropdown
          const posteToAdd = {
            value: value,
            name: foundPoste.name,
            ids: [value],
            types: [foundPoste.operationType],
            text: `${foundPoste.name} (${foundPoste.operationType})`,
            operationType: foundPoste.operationType
          }

          // Vérifier si le poste existe déjà dans le dropdown
          const existingPosteIndex = this.postes.findIndex(p => p.value === value)
          if (existingPosteIndex >= 0) {
            this.postes[existingPosteIndex] = posteToAdd
          } else {
            this.postes.push(posteToAdd)
          }

          // Ajouter ou mettre à jour le poste dans allPostes
          const existingAllPosteIndex = this.allPostes.findIndex(p => p.value === value)
          if (existingAllPosteIndex >= 0) {
            this.allPostes[existingAllPosteIndex] = posteToAdd
          } else {
            this.allPostes.push(posteToAdd)
          }

          this.postes.sort((a, b) => a.text.localeCompare(b.text))
        }
      }

      // Reset currentSelection to fix the placeholder bug
      this.currentSelection = ""
    },

    handleOk() {
      this.handleSubmit()
    },

    handleCancel() {
      this.hideModal()
    },

    handleSubmit() {
      const linkedIds = this.linkedConstructions.map(p => p.id)
      const selectedIds = [...this.selectedPostes]
      const allIds = [...new Set([...linkedIds, ...selectedIds])]

      const formData = new FormData()
      formData.append('simulationConstructionId', this.simulationConstruction.id)
      formData.append('operationConstructionIds', allIds.join(','))

      api
        .post('/simulationConstruction/linkOperationConstruction', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {

          this.$emit('didAddPosteTravaux', response.data)
          this.hideModal()
        })
        .catch(error => {
          console.error('Erreur lors de la liaison des constructions:', error)
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    hideModal() {
      this.$bvModal.hide(this.modalId)
    }
  }
}
</script>

<style scoped>


.custom-title {
  font-size: 1rem;
  color: var(--main-text-color);
}

.selected-badges {
  display: flex;
  flex-wrap: wrap;
}

.badge-custom {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.7rem;
  border-radius: 0.5rem;
  background-color: var(--dragee);
  border: 2px solid var(--main-blue-hover);
}

.badge-text {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: var(--main-color);
}

.badge-close {
  cursor: pointer;
  font-size: 1.8rem;
  line-height: 1;
  color: #000000;
}

.callout{
  background-color: transparent;
  color: var(--tertiary-text-color);
  padding: 0px;
  font-size: 0.8rem;
  margin-top:  -10px;
  border-radius: 0.5rem;
  margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/AddSimulationPosteTravauxModal.vue